import React, { useEffect, useRef, useState } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { UseFormSetValue } from 'react-hook-form';
import { DesignationProps, DesignationTableRecord } from '../../OrganisationsInterfaces';

interface DesignationEditorProps {
    isToolBar?: boolean;
    editRecord?: DesignationTableRecord | Record<string, never>;
    editModal?: boolean;
    setValue?: UseFormSetValue<DesignationProps>;
    readOnly?: boolean;
}

const DesignationEditor = (props: DesignationEditorProps) => {
    const { isToolBar = true, editModal, editRecord, setValue, readOnly = false } = props;
    const [responsibilities, setResponsibilities] = useState('');
    const quillRef = useRef<ReactQuill>(null);

    // Use type assertion to access quilldata safely if it exists
    const htmlContent = (editRecord as DesignationTableRecord)?.quilldata;

    const handlePaste = (e: ClipboardEvent) => {
        e.preventDefault();
        const clipboardData = e.clipboardData || (window as Window & typeof globalThis & { clipboardData: DataTransfer }).clipboardData;
        const pastedData = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

        const quill = quillRef.current?.getEditor();
        const selection = quill?.getSelection();

        if (selection) {
            quill?.clipboard.dangerouslyPasteHTML(selection.index, pastedData);
        } else {
            quill?.clipboard.dangerouslyPasteHTML(pastedData);
        }
    };

    useEffect(() => {
        const quillEditor = quillRef.current?.getEditor();

        if (quillEditor) {
            const editor = quillEditor.root;

            editor.addEventListener('paste', handlePaste);

            if (editModal === true && htmlContent) {
                quillEditor.clipboard.dangerouslyPasteHTML(htmlContent);
                setResponsibilities(htmlContent);
                setValue?.('roles', htmlContent);
            } else {
                setValue?.('roles', '');
            }
            return () => {
                editor.removeEventListener('paste', handlePaste);
            };
        }
    }, [editModal, htmlContent, setValue]);

    const handleChange = (value: string) => {
        if (readOnly) {
            return;
        }
        setResponsibilities(value);
        setValue?.('roles', value);
    };

    const modules = {
        toolbar: isToolBar && !readOnly,
    };

    const placeholder = 'Enter roles and responsibilities...';

    return (
        <div className='ql ql_text-editor relative jd-editor h-full'>
            <ReactQuill
                ref={quillRef}
                value={responsibilities}
                onChange={handleChange}
                placeholder={placeholder}
                modules={modules}
                className="h-full flex flex-col"
                readOnly={readOnly}
            />
            <style>{`
                .jd-editor .quill {
                    display: flex !important;
                    flex-direction: column !important;
                    height: 100% !important;
                }
                .jd-editor .ql-container.ql-snow {
                    order: 1 !important;
                    flex: 1 !important;
                    display: flex !important;
                    flex-direction: column !important;
                    min-height: 0 !important;
                    border: none !important;
                }
                .jd-editor .ql-editor {
                    flex: 1 !important;
                    overflow-y: auto !important;
                }
                .jd-editor .ql-toolbar {
                    order: 2 !important;
                    background: white !important;
                    border-top: 1px solid #ccc !important;
                    border-bottom: none !important;
                    border-left: none !important;
                    border-right: none !important;
                }
            `}</style>
        </div>
    );
};

export default DesignationEditor;
